import { Button } from "@repo/blacksmith-ui/button";
import { assetUrl } from "@/lib/assetUrl";
import { githubAppInstallUrl } from "@/lib/named-org";

export const CODESMITH_NEEDS_ORGANIZATION_TITLE =
  "[code]smith needs a GitHub organization";

/** Rendered by the [code]smith routes for a personal account. */
export function CodesmithNeedsOrganization({
  instanceSlug,
}: {
  instanceSlug: string | null;
}) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-6 text-center">
      <img
        src={assetUrl("codesmith/codesmith-3d-fallback.png")}
        alt=""
        aria-hidden
        width={120}
        height={120}
        draggable={false}
        className="pointer-events-none size-[120px]"
      />
      <div className="max-w-md space-y-2">
        <h1 className="type-page-title-l text-neutral-900 dark:text-neutral-100">
          {CODESMITH_NEEDS_ORGANIZATION_TITLE}
        </h1>
        <p className="type-body-s-regular text-neutral-500 dark:text-neutral-400">
          Personal accounts can&apos;t start [code]smith sessions. Install
          Blacksmith on a GitHub organization to work on its repositories.
        </p>
      </div>
      <Button asChild>
        <a href={githubAppInstallUrl(instanceSlug)}>Add an organization</a>
      </Button>
    </div>
  );
}
